var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "./App.css";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "./styles/scrollbar.css";
import { AppRouter } from "./routes/appRouter";
import { PublicRoutes } from "./routes/publicRoutes";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./authContext";
import i18Next from "i18next";
import { GetNavigationPages } from "./services/getNavigationPages";
import { coreTheme } from "./theme/core.theme";
import { useIdleLogout } from "./hooks/useIdleLogout";
var getHashParams = function () {
    var hash = window.location.hash.substring(1); // Remove the leading '#'
    var params = new URLSearchParams(hash);
    var accessToken = params.get("access_token");
    if (accessToken) {
        // You may store token here, e.g., localStorage or state
        console.log("MSI SSO DETECTED");
        localStorage.setItem("msi_access_token", accessToken);
    }
};
function App() {
    var status = useAuth().status;
    getHashParams(); // Call the function to check if there are is SSO token in the URL
    useIdleLogout(status !== "no-authenticated");
    // Inicializar los permisos para que estén disponibles en el cache
    GetNavigationPages();
    var lng = localStorage.getItem("i18nextLng")
        ? localStorage.getItem("i18nextLng")
        : "es";
    var ns = localStorage.getItem("i18nextDefaultNamespace")
        ? localStorage.getItem("i18nextDefaultNamespace")
        : "default";
    i18Next.loadNamespaces(ns, function () {
        if (ns) {
            i18Next.setDefaultNamespace(ns);
        }
        i18Next.changeLanguage(lng);
    });
    return (_jsx(BrowserRouter, { children: status !== "no-authenticated" ? (_jsx(AppRouter, {})) : (_jsxs(Routes, { children: [_jsx(Route, { path: "/*", element: _jsx(PublicRoutes, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/login", replace: true }) })] })) }));
}
var WrappedApp = function () { return (_jsx(MantineProvider, __assign({ theme: coreTheme }, { children: _jsx(AuthProvider, { children: _jsx(App, {}) }) }))); };
export default WrappedApp;
